import { NavigationGuardNext, Route } from 'vue-router'
import isEqual from 'lodash/isEqual'
import MarketingService from '@/services/marketing-service'
import store from '@/store'

export default function marketingGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (to.query.utm_campaign) {
    const userUtm = store.getters['auth/userUtm']
    const currentUtm = MarketingService.getUtm()

    if (!isEqual(userUtm, currentUtm) && store.getters['auth/isAuthenticated']) {
      MarketingService.sendUtm()
    }

    MarketingService.storeCampaign(to.query)
    return next()
  }

  const campaign = MarketingService.getCampaign()
  if (campaign) {
    return next({ path: to.path, query: { ...to.query, ...campaign } })
  }

  return next()
}
